import {Pipe, PipeTransform} from '@angular/core';
import {Diensten} from '../dienst/diensten';
import {ClientDienst} from './client-dienst';
import {Zone} from '../zone/zone';

@Pipe({
    name: 'zahClientDiensten',
    standalone: false
})
export class ClientDienstenPipe implements PipeTransform {
  transform(clientDiensten: Array<ClientDienst>, diensten: Diensten, zones: Array<Zone>): string {
    if (!diensten || !zones) {
      return '';
    } else {
      const clientDienstLabels = (clientDiensten || [])
        .map(clientDienst =>
          `${this.getDienstLabel(clientDienst.getId(), diensten)} - ${this.getZoneLabel(clientDienst.getZoneId(), zones)}`
        );
      return clientDienstLabels.length > 0 ? clientDienstLabels.join(', ') : 'Geen dienst';
    }
  }

  private getDienstLabel(dienstId: string, diensten: Diensten): string {
    return diensten.getDienst(dienstId)?.getLabel() || 'Onbekende dienst';
  }

  private getZoneLabel(zoneId: string, zones: Array<Zone>): string {
    return zones.find(zone => zone.getId() === zoneId)?.getLabel() || 'Onbekende zone';
  }
}
